module.exports = __webpack_public_path__ + "static/img/hn-user-avatar-img.6d460a23.jpeg";